import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-automation-work-flow',
  templateUrl: './automation-work-flow.component.html',
  styleUrls: ['./automation-work-flow.component.scss'],
})
export class AutomationWorkFlowComponent {
  @Output() saveOrUpdateWorkflow = new EventEmitter<{ payload: any; pathName: any }>();
  modalLabel: any;
  automationForm!: FormGroup;
  automationData: any;
  activatedRoute: any;

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.automationForm = this.formBuilder.group({
      workflowName: ['', Validators.required],
      isActive: ['', Validators.required],
      triggerType: [null, Validators.required],
    });
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.automationData = this.modal?.modalService?.config?.initialState?.['automationData'];
  }

  ngOnInit(): void {
    this.patchFormValues(this.automationData);
  }

  patchFormValues(data: any): void {
    var triggerType = this.automationData.triggerList.find((x: any) => x.id == data.triggerType);
    this.automationForm.patchValue({
      workflowName: data.workflowName,
      isActive: data.isActive,
      triggerType: triggerType,
    });
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    var data = {
      workflowName: this.automationForm.value.workflowName,
      workflowId: this.automationData.workflowId,
      isActive: this.automationForm.value.isActive,
      triggerType: this.automationForm.value.triggerType.id,
    };
    this.saveOrUpdateWorkflow.emit({ payload: data, pathName: this.activatedRoute });
  }
}
